import { Component, OnInit } from '@angular/core';
import { EmpresaService } from 'src/app/services/empresa.service';
import { EmpresaFacturas, FacturaDatos, ProductoDatos } from 'src/app/models/empresa-facturas.interface';
import { Router, ActivatedRoute } from '@angular/router';
import { TrazabilidadProducto } from '../../models/trazabilidad-producto.interface';


@Component({
    selector: 'app-factura-lst-empresa',
    templateUrl: './factura-lst-empresa.component.html',
    styleUrls: ['./factura-lst-empresa.component.scss'],
})

export class FacturaLstEmpresaComponent implements OnInit {
    public db: FacturaDatos[] = [];
    public empresa!: EmpresaFacturas;
    public visible: boolean = false;
    public producto!: ProductoDatos;
    constructor(private empresaService: EmpresaService, private active: ActivatedRoute) { }

    ngOnInit(): void {
        this.load();
    }

    load(): void {
        this.empresaService
            .empresaFacturas(this.active.snapshot.params['id'])
            .subscribe({
                next: (resp) => {
                    this.empresa = resp.datos;
                    this.db = this.empresa.facturas;

                }, error: (err) => { console.error(err.error.message) }
            });
    }
    trackByFactura(index: number, item: FacturaDatos) {
        return item.id;
    }
    trackByProducto(index: number, item: ProductoDatos) {
        return item.id;
    }
    showDialog(producto: ProductoDatos) {
        this.producto = producto;
        this.visible = true;
    }
}